module.exports = __webpack_public_path__ + "img/client-3.2f0ed113.png";